import React, { useState, useEffect } from "react";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import LogoImage from "../../atoms/LogoImage";
import TitleText from "../../atoms/TitleText";
import PlantAnimation from "../../atoms/PlantAnimation.jsx";
import { RESOLVED_THEMES } from "../../../theme/theme.constants";
import { useThemeMode } from "../../../theme/ThemeModeProvider";

const SHARE_ERROR_MESSAGE = "Error sharing:";
const SHARE_UNSUPPORTED_MESSAGE = "Web Share API not supported in this browser.";
const NETPAD_TAGLINE = "Paste here. Pick up anywhere.";

const getFormattedDate = () => {
  const options = { weekday: "long", month: "long", day: "numeric" };
  return new Date().toLocaleDateString("en-US", options);
};

const ThemeToggleButton = () => {
  const { resolvedTheme, toggleTheme } = useThemeMode();
  const isDark = resolvedTheme === RESOLVED_THEMES.DARK;
  const Icon = isDark ? LightModeIcon : DarkModeIcon;
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      aria-label={label}
      className="flex h-9 w-9 items-center justify-center rounded-md text-primary hover:bg-surface-muted"
      onClick={toggleTheme}
      type="button"
    >
      <Icon fontSize="small" />
    </button>
  );
};

const Header = ({
  title = "Default Title",
  padding,
  onClick,
}) => {
  const [currentDate, setCurrentDate] = useState(getFormattedDate());

  useEffect(() => {
    const interval = setInterval(() => {
      const newDate = getFormattedDate();
      setCurrentDate(newDate);
    }, 1000 * 60);
    return () => clearInterval(interval);
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          text: NETPAD_TAGLINE,
          url: window.location.href,
        });
        console.log("Successful share");
      } catch (error) {
        console.error(SHARE_ERROR_MESSAGE, error);
      }
    } else {
      console.error(SHARE_UNSUPPORTED_MESSAGE);
    }
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div
        className={`flex items-center ${padding} gap-1 cursor-pointer`}
        onClick={onClick}
      >
        <LogoImage className="w-9 h-9" />
        <TitleText
          title={title}
          className="ml-2 font-sen"
          animateText
        />
      </div>
      <div className="flex items-center gap-4 pr-4">
        <ThemeToggleButton />
        <div className="date-flip hidden md:block text-text-muted text-sm font-montserrat">
          <span className="flex items-center gap-1">
            {currentDate} <PlantAnimation />
          </span>
        </div>
        <div className="md:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.0}
            stroke="currentColor"
            className="h-5 w-5 text-primary cursor-pointer"
            onClick={handleShare}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Header;
